import { render, staticRenderFns } from "./ABTest.vue?vue&type=template&id=138e1d11&scoped=true"
import script from "./ABTest.vue?vue&type=script&lang=js"
export * from "./ABTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138e1d11",
  null
  
)

export default component.exports